// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cineplexx-widget{border-width:1px;--tw-border-opacity:1;border-color:rgb(227 5 27 / var(--tw-border-opacity))}.cineplexx-widget__title{--tw-bg-opacity:1;background-color:rgb(227 5 27 / var(--tw-bg-opacity));padding:0.5rem;font-family:VNPolarisWeb, Arial Narrow, sans-serif;font-size:1rem;font-weight:900;--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
